import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, getCurrentInstance, onMounted, computed, ref } from 'vue';
import { CountrySource, OrganizationCountrySource } from '@/Sources';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryDropdownField',
  props: {
    value: { type: String, required: false },
    label: { type: String, required: false, default: 'Country' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false },
    useOrganizationApi: { type: Boolean, required: false, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: $emits }: { emit: ({ (event: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string, label: string, disabled: boolean, autoAssign: boolean, placeholder?: string, useOrganizationApi: boolean };

const instance = getCurrentInstance();




const source = ref(props.useOrganizationApi === true ? new OrganizationCountrySource() : new CountrySource());

const onValueChanged = (evt: CustomEvent<string>) => {
  val.value = evt.detail;
};

const val = computed({
  get: () => props.value ?? '',
  set: (value: string) => $emits('input', value)
});

onMounted(() => {
  const dropdown = instance?.proxy.$el.querySelector('samc-dropdown-input') ?? null;
  if (dropdown !== null && dropdown.source === undefined) {
    dropdown.source = source.value as any;
  }
});

return { __sfc: true,instance, props, $emits, source, onValueChanged, val }
}

})